<template>
  <div>
    <v-app-bar app color="#00b2bb" dark>
      <img class="mr-4" src="../../assets/logoNotariaBlanco.png" style="max-height: 30%;width: auto" >
      <v-toolbar-title class="title-size font-weight-light">Notaría Ronchera</v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="text-center">
        <v-menu offset-y>
          <template v-slot:activator="{ on }" class="button-size">
            <v-btn
              dark
              v-on="on"
              rounded
              color="teal"
              class="font-weight-light text-size span button-size"
            >
              Registrarse
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              :to="item.route"
              v-for="(item, index) in items"
              :key="index" link
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <!-- <v-btn text rounded :to="'/signup'" class="font-weight-light">Registrarse</v-btn> -->
      <!-- <v-btn text rounded :to="'/'" class="font-weight-light">Acceder</v-btn> -->
    </v-app-bar>
    <v-app>
      <div class="background-display imgen">
      <v-container>
      <v-card max-width="400" class="mx-auto ma-5">
        <v-toolbar dark color="#00b2bb">
          <v-card-title>
            <span class="headline font-weight-thin">Iniciar Sesión</span>
          </v-card-title>
        </v-toolbar>
        <v-progress-linear v-if="apiRequest"
            indeterminate
            color="teal" dark
            ></v-progress-linear>
        <v-card-text>
          <v-alert v-model="alert" border="left" close-text="Close Alert" dismissible dense outlined type="error">
            Correo o Contraseña invalido
          </v-alert>
          <v-alert v-if="$route.query.fail" border="left" close-text="Close Alert" dismissible dense outlined type="error">
            Validación de identidad Fallida. Por favor intente de nuevo.
          </v-alert>
          <v-form ref="form">
            <EmailField
                v-model="email"
                :name="email"
                :schema="{
                  label: 'Correo',
                  icon: 'mdi-email'
                }"
                solo
              >
              </EmailField>
              <PasswordField
                v-model="password"
                :name="password"
                :schema="{
                   label: 'Contraseña',
                   icon:'mdi-lock'
                 }"
                >
               </PasswordField>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mt-5 justify-center">
          <!-- <v-btn color="normal" :to="'/'">Cancelar</v-btn>
          <v-spacer></v-spacer> -->
          <v-btn color="#00b2bb" dark @click="validationRules">Iniciar</v-btn>
        </v-card-actions>
        <p class="ma-2" align="right"><a href="forgotpassword">Recuperar contraseña</a></p>
      </v-card>
      </v-container>
      </div>
    </v-app>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<style>
.background-display {
  background-color: #f5f5f5 !important;
  width: auto;
  min-height: 100%;
}
.complete-text {
  word-break: normal;
}
@media only screen and (min-device-width: 300px) and (max-width: 370px) {
  .title-size {
    font-size:1em !important;
  }
  .text-size span {
    font-size:1em !important;
  }
  .button-size {
   padding: 8px !important;
  }
}
@media only screen and (min-device-width: 600px) and (max-width: 1906px) {
  .imgen {
    background-image: url('../../assets/banqueta.png');
  }
}
@media only screen and (min-device-width: 1906px) {
  .imgen {
    background-image: url('../../assets/calle.png');
    max-height: 50%;
  }
}
</style>
<script>
/* import { Auth } from 'aws-amplify' */
import { Auth } from '@aws-amplify/auth'
import { AmplifyEventBus } from 'aws-amplify-vue'
import moment from '@/plugins/moment'
import EmailField from '../../components/fields/email/Field.vue'
import PasswordField from '../../components/fields/password/Field.vue'
// @ is an alias to /src
export default {
  name: 'Login',
  components: {
    EmailField,
    PasswordField
  },
  data: () => ({
    // Para mostrar el rut y pasaporte en el appbar
    items: [
      { title: 'RUT', route: '/signup' },
      { title: 'Pasaporte', route: '/signuppassport' }
    ],
    // para validacion de fecha de conexion
    date: '',
    finalDate: moment().format(),
    showPassword: false,
    alert: false,
    apiRequest: false,
    overlay: false,
    email: '',
    password: '',
    signedIn: false
  }),
  mounted () {
    this.isUserSignedIn()
    AmplifyEventBus.$on('authState', info => {
      if (info === 'signedIn') {
        this.signedIn = true
        this.isUserSignedIn()
      } else {
        this.signedIn = false
      }
    })
  },
  watch: {
    overlay (val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 5000)
    }
  },
  /* Metodo para saber si el usuario esta logeado */
  methods: {
    async loginUser () {
      this.apiRequest = true
      try {
        /* const response = */ await Auth.signIn(this.email, this.password)
        /* console.log('Confirmacion Autenticado: ', response) */
        this.date = moment().format()
        localStorage.setItem('date', JSON.stringify(this.date))
        localStorage.setItem('email', JSON.stringify(this.email))
        /* this.$store.commit('setUserEmail', this.email)
        this.$store.commit('setLoginDate', this.date) */
        this.isUserSignedIn()
        /* this.$router.push({ path: '/mydocument/documentlist' }) */
        /* localStorage.setItem('confirmAuth', JSON.stringify(confirmAuth)) */
        this.apiRequest = false
      } catch (error) {
        this.alert = true
        this.apiRequest = false
        console.log('Error confirmacion de usuario: ' + error)
      }
    },
    async isUserSignedIn () {
      /* this.currentSesion() */
      try {
        const userObj = await Auth.currentAuthenticatedUser()
        this.signedIn = true
        this.$store.commit('setAuthentication', true)
        this.$store.commit('setUser', userObj)
        this.overlay = !this.overlay
        this.identityValidation(userObj)
        this.sessionDate()
        if (!JSON.parse(localStorage.getItem('date'))) {
          this.logout()
        }
        this.$router.replace({ path: this.$route.query.to || '/newdocument/selectdocument' })
        /* console.log(userObj)
        console.log('Usuario obtenido: ' + userObj)
        console.log('Esta logueado: ' + this.signedIn) */
      } catch (error) {
        this.$store.commit('setAuthentication', false)
        this.signedIn = false
        console.log('Error de autenticacion: ' + error)
      }
    },
    validationRules () {
      if (this.$refs.form.validate()) {
        this.loginUser()
      }
    },
    async currentSesion () {
      try {
        /* const activeSesion = */ await Auth.currentSession()
        this.$store.commit('setAuthentication', true)
        /* console.log('Entro al active sesion')
        console.log(activeSesion) */
      } catch (error) {
        this.$store.commit('setAuthentication', false)
        console.log('Error sesion terminada: ' + error)
      }
    },
    // Se utiliza para la validacion de identidad
    identityValidation (userObj) {
      if (userObj.attributes['custom:verificado'] === '0') {
        console.log('Entro en 0')
        /* window.open('https://www.geeksforgeeks.org', '_self') */
      } else {
        console.log('Entro en 1')
        /* this.$router.replace({ path: this.$route.query.to || '/newdocument/selectdocument' }) */
      }
    },
    // Para Verificar el tiempo de conexion de un usuario, lo desloguea si tiene mas de un dia
    sessionDate () {
      const logDate = new Date(JSON.parse(localStorage.getItem('date')))
      logDate.setDate(logDate.getDate() + 1)
      const actualDate = new Date()
      if (logDate < actualDate || (JSON.parse(localStorage.getItem('date')) === null)) {
        /* console.log('Tiene mas de un dia conectado') */
        this.logout()
      }
      /* console.log('Login ' + moment(JSON.parse(localStorage.getItem('date'))).format('DD-MM-YYYY'))
      console.log('Actual ' + moment(actualDate).format('DD-MM-YYYY')) */
    },
    async logout () {
      try {
        await Auth.signOut()
        localStorage.removeItem('nuevo_usuario')
        localStorage.removeItem('usuario')
        localStorage.removeItem('date')
        localStorage.removeItem('email')
        localStorage.removeItem('name_doc')
        this.$router.push({ path: '/' })
        console.log('logout')
      } catch (error) {
        console.log('Error al cerrar sesion ' + error)
      }
    }
  }
}
</script>
